export enum Role {
  All = "All",
  Admin = "Admin",
  Agent = "Agent",
  Customer = "Customer",
}
